import React from "react";
import Card from "../../newComponents/card";
import SectionListing from "../../newComponents/sectionListing";

const relatedNews = ({ block }) => (
  <SectionListing title={block.headline} primaryBackground={true}>
    {block.featuredNewsEntries.map((item) => (
      <Card key={item.uri} image={item.featureImage[0]} title={item.displayTitle} subtitle={item.summary} href={`/${item.uri}`}/>
    ))}
  </SectionListing>
);

export default relatedNews;